var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4040_124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4040_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70005 18.0001L1.05005 12.3501L2.47505 10.9501L8.12505 16.6001L6.70005 18.0001ZM12.35 18.0001L6.70005 12.3501L8.10005 10.9251L12.35 15.1751L21.55 5.9751L22.95 7.4001L12.35 18.0001ZM12.35 12.3501L10.925 10.9501L15.875 6.0001L17.3 7.4001L12.35 12.3501Z",
    fill: "#1D8145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done_all.3415ca58ad4d5ad15784673bda47315e.svg";
export { ForwardRef as ReactComponent };